export const SUPPORTED_LOCALES = ["en-US", "en-CA"] as const;
export type SupportedLocale = typeof SUPPORTED_LOCALES[number];

export const DEFAULT_LOCALE: SupportedLocale = "en-US";

export const LOCALE_TO_OG = (l: SupportedLocale) => l.replace("-", "_");

export function buildAlternateUrl(pathname: string, locale: SupportedLocale) {
  try {
    const origin = window.location.origin;
    const url = new URL(pathname, origin);
    // Use a stable query param for locale without affecting routing
    url.searchParams.set("hl", locale);
    return url.toString();
  } catch {
    // Fallback for non-browser contexts
    return `https://a1softball.com${pathname}?hl=${locale}`;
  }
}
